import React from 'react';
export function MiniTroopersFAQHeader() {
  return <h2 className="text-4xl text-ink text-center mb-16" data-id="element-2531">Common Questions</h2>;
}